(() => {
  if (customElements.get('cart-selling-plan-toggle')) {
    return;
  }

  class CartSellingPlanToggle extends HTMLElement {
    constructor() {
      super();
      this.data = {
        line: Number(this.getAttribute('data-item-index')),
        quantity: Number(this.getAttribute('data-quantity')),
        selling_plan: Number(this.getAttribute('data-plan-id'))
      };
    }

    updateItem() {
      if (this.hasSelectedPlan) {
        this.data.selling_plan = null;
      }

      this.closest('cart-items')?.updateCart({
        ...this.data,
        isUpdating: true
      }, this.closest('[data-item]'));
    }

    init() {
      this.hasSelectedPlan = this.checkbox.checked;

      this.checkbox.addEventListener('change', this.updateItem.bind(this));
    }

    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');

      this.init();
    }
  }

  customElements.define('cart-selling-plan-toggle', CartSellingPlanToggle);
})();
